export const painPoints = [
  {
    emoji: '🌙',
    title: 'Your last session ends, your notes don’t',
    desc: 'Six or seven clients a day, then the notes you write at night, tired, trying to remember what was said at 10 am.',
  },
  {
    emoji: '🧾',
    title: 'Documentation anxiety',
    desc: 'Is this note clear enough? Does it link to the treatment plan? Would it hold up in an audit or an insurance review?',
  },
  {
    emoji: '🗂️',
    title: 'The paperwork never stops',
    desc: 'Treatment plans, plan reviews, handouts, letters, emails, policies. All of it outside the session hour, none of it paid.',
  },
  {
    emoji: '🤖',
    title: 'You tried AI and it sounded generic',
    desc: 'Without the right instructions, AI writes vague notes, adds things that never happened or asks you for identifying data.',
  },
];
